import { BonusType } from '@/webgl/runner/entities/BonusEntity'
import { CollectibleType } from '@/webgl/runner/entities/CollectibleEntity'
import { CollectibleResourceType as CollectibleResourceType } from '@/webgl/runner/rendering/CollectibleRenderer'
import { SequenceAlternativeMode, SequenceViewVariant } from '@/webgl/runner/scenarios/SequenceConfig.types'

import { ScenarioSetup } from '../ScenarioSetup.types'

const { Standard, Obstacle, TurningPoint, Bonus } = CollectibleType
const { Text, Pack } = CollectibleResourceType

const scrolling_items = ['apple', 'can', 'cereal', 'jam', 'milk', 'sardines_can_1', 'sardines_can_2', 'shopping_bag']

const shopping_items = ['apples', 'brocoli', 'can', 'carrot', 'cereal', 'cherries', 'jam', 'milk', 'sardines']

const shopping_list_1 = ['apples', 'brocoli', 'can', 'carrot', 'cereal']
const shopping_list_2 = ['cherries', 'jam', 'milk', 'sardines']

const config: ScenarioSetup = {
  backgroundColor: 0xf1e2bd,
  lanesColor: 0x06748d,
  lanesExtraColor: 0x4ea4bd,
  lanesTextureId: 'ticket',

  clearColor: 0xfff4e5,
  smokeColor: 0xf7ead8,

  playerColor: 0xf1e2bd,
  playerGoodColor: 0xfce5ab,
  playerWrongColor: 0xfe8769,

  audioSfx: { path: 'sfx_audio/sfx.json' },
  audio: {
    en: {
      path: 'francesca_2/audios/en/bundle_1.json',
      subtitles: 'francesca_2/audios/en/bundle_1.vtt',
    },
  },

  collectibles: {
    resources: [
      {
        type: Pack,
        request: 'francesca_2/collectible.glb',
      },

      {
        type: Text,
        text: {
          font: 'fonts/UnderstoodSans-Heavy',
          values: [],
        },
      },
    ],

    items: [
      {
        id: 'apples',
        variants: ['two_apples', 'one_apple_01', 'one_apple_02'],
        prices: [2, 3, 4],
        type: Standard,
      },
      {
        id: 'brocoli',
        prices: [1.5, 2, 3.5],
        type: Standard,
      },
      {
        id: 'can',
        prices: [3, 4.5, 6],
        type: Standard,
      },
      {
        id: 'carrot',
        prices: [2.5, 4, 5],
        type: Standard,
      },
      {
        id: 'cereal',
        prices: [2, 3, 4],
        type: Standard,
      },
      {
        id: 'cherries',
        prices: [3.5, 5, 6],
        type: Standard,
      },
      {
        id: 'jam',
        prices: [2, 3, 4],
        type: Standard,
      },
      {
        id: 'milk',
        prices: [1, 2, 3],
        type: Standard,
      },
      {
        id: 'sardines',
        variants: ['sardine_01', 'sardine_02', 'sardines_03'],
        prices: [1.5, 3, 4],
        type: Standard,
      },

      {
        id: 'price',
        type: Obstacle,
        bonus: BonusType.AltPrice,
        audio: 'TYCE_francesca_Scratch_oh no what is this 1_1',
      },
      {
        id: 'phone_calculator',
        type: Obstacle,
        bonus: BonusType.PhoneCalculator,
        audio: 'TYCE_francesca_Scratch_phew finally 2',
      },
      {
        id: 'deep_breath',
        type: Bonus,
        bonus: BonusType.Relax,
        // audio: "TYCE_francesca_Scratch__ah-that-feels-1"
      },
      {
        id: 'brain_freeze',
        type: Obstacle,
        bonus: BonusType.Freeze,
        audio: 'TYCE_francesca_Scratch_oh no',
        // audio: "TYCE_francesca_Scratch_whenever Im counting 1"
      },
      {
        id: 'coins',
        type: Bonus,
        bonus: BonusType.PriceCoins,
      },
      {
        id: 'receipt',
        type: Standard,
      },

      // coin_01
      // coin_02
      // coin_03
      // price
      // tag
    ],
  },

  particles: {
    resources: [{ id: 'default', request: 'common/particles.glb' }],
  },

  background: {
    resources: [
      {
        id: 'background',
        request: 'francesca_2/background.glb',
      },
    ],

    items: [
      { id: 'apple' },
      { id: 'can' },
      { id: 'cereal' },
      { id: 'jam' },
      { id: 'milk' },
      { id: 'sardines_can_1' },
      { id: 'sardines_can_2' },
      { id: 'shopping_bag' },
    ],
  },

  sequences: [
    //#region shopping
    {
      id: 'shopping',
      goals: [['apples'], ['brocoli'], ['can'], ['carrot'], ['milk'], ['sardines']],

      alternativeMode: SequenceAlternativeMode.Shopping,

      view: {
        variant: SequenceViewVariant.Shopping,
        // unordered: true
      },

      track: {
        type: 'gate-track',
        gates: [
          { pool: ['apples'], goals: ['apples'] },
          { pool: ['brocoli'], goals: ['brocoli'] },
          { pool: ['can'], goals: ['can'] },
          { pool: ['carrot'], goals: ['carrot'] },
          { pool: ['milk'], goals: ['milk'] },
          { pool: ['sardines'], goals: ['sardines'] },
        ],
        rate: 8,
      },

      scrolling: scrolling_items,
    },

    {
      id: 'shopping_bis',
      goals: [['cereal'], ['cherries'], ['jam'], ['milk'], ['sardines'], ['can'], ['brocoli']],

      alternativeMode: SequenceAlternativeMode.Shopping,

      view: {
        variant: SequenceViewVariant.Shopping,
        // unordered: true
      },
      track: {
        type: 'gate-track',
        gates: [
          { pool: ['coins'], goals: ['coins'] },
          { pool: ['cereal'], goals: ['cereal'] },
          { pool: ['cherries'], goals: ['cherries'] },
          { pool: ['jam'], goals: ['jam'] },
          { pool: ['milk'], goals: ['milk'] },
          { pool: ['sardines'], goals: ['sardines'] },
          { pool: ['can'], goals: ['can'] },
          { pool: ['brocoli'], goals: ['brocoli'] },
        ],
        rate: 9,
      },

      scrolling: scrolling_items,
    },
    //#endregion

    //#region receipt
    {
      id: 'receipt',
      goals: [['receipt']],

      view: {
        variant: SequenceViewVariant.Hidden,
      },

      track: {
        type: 'gate-track',
        gates: [{ pool: ['receipt'], goals: ['receipt'] }],
        rate: 8,
      },

      scrolling: scrolling_items,
    },
    //#endregion

    //#region shopping_balance
    {
      id: 'shopping_balance',
      goals: [[]],
      alternativeMode: SequenceAlternativeMode.ShoppingBalance,

      start: {
        alterJauge: 1,
      },

      stop: {
        preserveBonus: true,
      },

      track: {
        type: 'shopping-balance',
      },

      view: {
        variant: SequenceViewVariant.Hidden,
        unordered: true,
      },

      scrolling: scrolling_items,
    },
    //#endregion
  ],

  turningPoints: [],

  audioSegments: [
    {
      id: 'audio_intro',
      audios: ['TYCE_francesca_Scratch_my mom 1'],
    },
    {
      id: 'audio_shop',
      audios: ['TYCE_francesca_Scratch_I need to collect'],
    },
    {
      id: 'audio_receipt',
      audios: ['TYCE_francesca_Scratch_cashier_ok'],
    },
    {
      id: 'audio_balance',
      audios: ['TYCE_francesca_Scratch_oh shoot', 'TYCE_francesca_Scratch_I struggle 1'],
    },
    {
      id: 'audio_outro',
      audios: [
        'TYCE_francesca_Scratch_whenever Im counting 1',
        'TYCE_francesca_Scratch_thank-you-for-shopping-1',
        'TYCE_francesca_Scratch_wait a second',
      ],
    },
  ],
}

export default config
